const LIST_MIN_LIMIT = 10
const LIST_MAX_LIMIT = 40

class DescriptionsApi {
  constructor(baseUrl, token) {
    this.baseUrl = baseUrl
    this.token = token
  }

  async fetchJson(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'application/json',
        'X-Version': '1',
        ...options.headers
      }
    })

    const data = await response.json()

    if (data && data.error) {
      throw data.error
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return data.data
  }

  async getDescriptionsList({ page = 1, limit = LIST_MIN_LIMIT, name = '', game } = {}) {
    const body = {
      page: Math.max(1, page),
      limit: Math.min(LIST_MAX_LIMIT, Math.max(LIST_MIN_LIMIT, limit))
    }

    if (name && name.trim()) {
      body.name = name.trim()
    }

    if (game !== undefined && game !== null) {
      body.game = game
    }

    return this.fetchJson(`${this.baseUrl}/descriptions/list`, {
      method: 'POST',
      body: JSON.stringify(body)
    })
  }

  async createDescription({ game, name, values }) {
    return this.fetchJson(`${this.baseUrl}/descriptions/create`, {
      method: 'POST',
      headers: {
        'X-Version': '2'
      },
      body: JSON.stringify({
        game,
        name,
        values: values || {}
      })
    })
  }

  async updateDescription(id, { game, name, values } = {}) {
    const body = {}

    if (game !== undefined && game !== null) {
      body.game = game
    }

    if (name) {
      body.name = name
    }

    if (values) {
      body.values = values
    }

    return this.fetchJson(`${this.baseUrl}/descriptions/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body)
    })
  }

  async deleteDescriptionById(id) {
    return this.fetchJson(`${this.baseUrl}/descriptions/${id}`, {
      method: 'DELETE',
      headers: {
        'X-Version': '2'
      }
    })
  }
}

export default DescriptionsApi 